import React, { useState } from "react";
import iconSearch from "../../img/searchIcon.svg";
import iconTrailing from "../../img/trailingIcon.svg";
import Filters from "../Filters/Filters";

const Search = (props) => {

  const {
    value,
    setValue,
    getListCargoCase,
    setGetListCargoCase,
    getContainerClass,
    optionFilterCargoCaseConsignee,
    optionFilterCargoCaseVessel,
    optionFilterCargoCaseShipper,
    optionFilterCargoCaseCarrier,
    optionFilterCargoCaseDate
  } = props;

  const [isActiveFilterModal, setActiveFilterModal] = useState(false);

  const onHandlerFilters = (typeFilter, valueFilter) => {
    if(typeFilter && valueFilter) {
        switch(typeFilter) {
          case 'consignee' : 
              setGetListCargoCase(getListCargoCase.filter(el => el.consignee === valueFilter))
              setActiveFilterModal(false);      
            break;
          case 'vessel' : 
              setGetListCargoCase(getListCargoCase.filter(el => el.vessel.name === valueFilter));
              setActiveFilterModal(false);   
            break;
          case 'carrier' : 
              setGetListCargoCase(getListCargoCase.filter(el => el.shipowner.name === valueFilter));
              setActiveFilterModal(false); 
            break;
          case 'shipper' : 
              setGetListCargoCase(getListCargoCase.filter(el => el.shipper.name === valueFilter));
              setActiveFilterModal(false); 
            break;
          case 'date' : 
              setGetListCargoCase(getListCargoCase.filter(el => el.dateOfCreation === valueFilter));
              setActiveFilterModal(false);  
            break;      
          default: return typeFilter
      }
    }
  }
  
  return (
    <div className="search__container">
      <img className="search-icon" src={iconSearch} alt={"иконка поиск"} />
      <input
        className="search-input"
        type={"search"}
        placeholder={"Search"}
        value={value}
        onChange={(evt) => setValue?.(evt.target.value)}
      />
      <img
        onClick={() => setActiveFilterModal(!isActiveFilterModal)}
        className={getContainerClass ? "search-icon-trailing" : "search-icon-trailing-default"}
        src={iconTrailing}
        alt={"иконка поиска"}
      />
      {isActiveFilterModal && getContainerClass && <Filters
          closeModal={() => setActiveFilterModal(false)}
          onHandlerFilters={onHandlerFilters}
          optionFilterCargoCaseConsignee={optionFilterCargoCaseConsignee}
          optionFilterCargoCaseVessel={optionFilterCargoCaseVessel}
          optionFilterCargoCaseShipper={optionFilterCargoCaseShipper}
          optionFilterCargoCaseCarrier={optionFilterCargoCaseCarrier}
          optionFilterCargoCaseDate={optionFilterCargoCaseDate}
      />}
    </div>
  );
};
export default Search;
